import { Button, Col, Form, Modal, Row, Select } from "antd"
import { enqueueSnackbar } from "notistack"
import { useEffect, useState } from "react"
import { GetLicenseManagementSoftwares, GetVersionBySoftwareId, axiosErrorMessages } from "../../../API/api"
import axios, { AxiosError } from "axios";
import { Backdrop, CircularProgress } from "@mui/material";
interface AddSoftwareVersion {
    populateListData: (data: any) => void;
    onClose: ()=>void;
    editSoftwareDetails:any;
    isEdit:boolean;
    softwareId:number;
    versionId:number;
  }

  type SoftwareList = {
    label:string;
    value:number;
    isOs:boolean;
  }
    const AddSoftware: React.FC<AddSoftwareVersion> = ({ populateListData,onClose ,editSoftwareDetails,isEdit,softwareId,versionId}) => {
        const [isOpen,setIsOpen] = useState<boolean>(true)
    const onClosePopup = () =>{setIsOpen(false); onClose()}
    const onSaveSoftwareHandler = (data:any) => {
      const isOs:any = softwareList.find((software: any) => software.value === data.softwareId)?.isOs;
      const saveData = {
        ...data,
        isos: isOs,
    };
setIsOpen(false)
        populateListData(saveData)
    }

    useEffect(()=>{
      if(isEdit)    {
        getSoftwareVersions(softwareId)
        setFormData()

      }
    },[])
    
    const setFormData = () => {
      addLicenseForm.setFieldsValue({
        softwareId:softwareId,
        versionId:versionId
      }
      )
    }
    const [versionList,setVersionList] = useState([])
    const getSelectedSoftwareVersions = (event:any) => {
      addLicenseForm.resetFields(['versionId']);
      getSoftwareVersions(event)

    }
    const getSoftwareVersions = async (event:any) => {
        try {
          setIsLoading(true);
          const response = await GetVersionBySoftwareId(event);
          const newData = response.data.versions.map((version: any, index: number) => ({
            value: version.versionId,
            label: version.version,
          }));
          setVersionList(newData);

          setIsLoading(false);
        } catch (error: any) {
          enqueueSnackbar(error, {
            variant: "error",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
          setIsLoading(false);
        }
    
      }
      
    const [softwareList,setSoftwareList] = useState<SoftwareList[]>([])
    const [addLicenseForm] = Form.useForm()
    const [isLoading,setIsLoading] = useState<boolean>(false)
    useEffect(() => {
  
        GetOsList();
      }, []);


      const GetOsList = async () => {
        try {
          setIsLoading(true);
          const response = await GetLicenseManagementSoftwares();
          const newData = response.data.map((device: any, index: number) => ({
            label: device.softwareName,
            value: device.softwareId,
            isOs: device.isOs
          }));
          setSoftwareList(newData);
          setIsLoading(false);
        } catch (error:any) {
          let errorMsg;
          if (axios.isAxiosError(error)) {
            const axiosError = error as AxiosError;
            errorMsg = axiosErrorMessages(axiosError);
          } else {
            errorMsg = error.message;
          }
          enqueueSnackbar(errorMsg, {
            variant: "error",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
          // enqueueSnackbar("Error in fetching data", {
          //   variant: "error",
          //   anchorOrigin: {
          //     vertical: "top",
          //     horizontal: "right",
          //   },
          // });
          setIsLoading(false);
        }
      };

      const filterOption = (
        input: string,
        option?: { label: string; value: number }
      ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

    return (
      <>
      <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme: any) => theme.zIndex.drawer + 1,
      }}
      open={isLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
        <Modal
        maskClosable={false}
        footer={null}
        title="Add Software"
        onCancel={onClosePopup}
        open={isOpen}
      >
        
 <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 24 }}
          style={{ maxWidth: 1000 }}
          onFinish={onSaveSoftwareHandler}
          autoComplete="off"
          form={addLicenseForm}
        >
           <Row gutter={16} style={{marginTop: "20px"}}>
              <Col className="gutter-row" lg={12} sm={24}>
          <Form.Item
            rules={[{ required: true, message: "Enter Name" }]}
            name="softwareId"
          >
              <Select
           
            style={{ width: "100%" }}
            placeholder="Select Software"
            options={softwareList}
            filterOption={filterOption}
            showSearch
            onSelect={getSelectedSoftwareVersions}
          />
       
          </Form.Item>
          </Col>
              <Col className="gutter-row pm-search-flex" lg={12} sm={24}>
          <Form.Item
            name="versionId"
            rules={[{ required: true, message: "Select version" }]}

          >
              <Select
           style={{ width: "100%" }}
           placeholder="Select Version"
           options={versionList}
           filterOption={filterOption}
           showSearch
         />
          </Form.Item>
          </Col>
            </Row>         

          <Button className="pm-btn" htmlType="submit" type="primary" >
            Add Software
          </Button>

          </Form>
          </Modal>
      </>
      
    )
}

export default AddSoftware;